module.exports = __webpack_public_path__ + "static/media/green-grey.ec7706af.png";